<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">Pipacs Pékség - {{ __('Rendelés') }}</h1>
        <p class="mb-16 text-center">{{ __('Szeretettel köszöntünk a Pipacs Pékség rendelési felületén!') }}</p>
        <p class="mb-16 text-center">{{ __('A rendszer használatához regisztráció szükséges. Amennyiben már regisztráltál, kérjük jelentkezz be az email címed és a jelszavad megadásával!') }}</p>
        <p class="mb-16 text-center"><strong v-html="__('Rendelési rendszerünk megújult, használatához új regisztrációra van szükség (név, e-mail cím, telefonszám), ami kb fél percet vesz igénybe.<br />A desktop verzió mellett már mobilapplikációval is használható.')"></strong></p>
        <div class="flex justify-center gap-4 mb-16">
            <a href="https://apps.apple.com/hu/app/pipacs-rendel%C3%A9s/id6744015744" target="_blank"><img class="h-12" src="/img/app-store.png" /></a>
            <a href="https://play.google.com/store/apps/details?id=hu.pipacspekseg.rendeles&pli=1" target="_blank"><img class="h-12" src="/img/play-store.png" /></a>
        </div>

        <nav class="flex flex-col items-center justify-center md:flex-row">
            <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 md:mb-0 md:mr-4 normal-case px-4 py-2 rounded-none text-center !text-lg text-white transition-colors w-48" router
                      v-bind:to="{ name: 'login' }"
            >
                {{ __('Bejelentkezés') }}
            </c-button>
            <c-button class="border-2 border-slate-800 font-semibold hover:border-highlight hover:text-highlight mb-4 md:mb-0 md:mr-4 normal-case px-4 py-2 rounded-none text-center !text-lg text-slate-800 transition-colors w-48" router
                      v-bind:to="{ name: 'register' }"
            >
                {{ __('Regisztráció') }}
            </c-button>
        </nav>
    </div>
</template>

<script setup lang="ts">
    import { onMounted } from 'vue';
    import {
        CButton,
    } from '@teamfurther/cinderblock';
    import { useRequestStore }  from '../stores/request';
    import { useSessionStore }  from '../stores/session';

    const requestStore = useRequestStore();
    const sessionStore = useSessionStore();

    onMounted(async () => {
        if (sessionStore.user) {
            requestStore.redirect({ name: 'order' });
        }
    });
</script>
